import { MarketingShell } from "@/components/landing/MarketingShell";
import { Comparison } from "@/components/landing/Comparison";
import { SeoHead } from "@/components/useSeo";

const Page = () => (
  <MarketingShell>
    <SeoHead
      path="product-comparison"
      title="DollarDeploy vs Alternatives"
      description="Compare DollarDeploy to Heroku, Render, Railway and other deployment platforms."
    />
    <section className="container py-20">
      <Comparison />
    </section>
  </MarketingShell>
);

export default Page;
